// Ficha de producto: los "ADICIONALES" son variantes del producto (Sin
// adicionales / Libro / Mate / Libro + Mate), así que el pedido sigue siendo una
// sola línea con el peso de la caja (del que dependen las fechas del carrito) y
// el contenido para el picking. Acá se los muestra como interruptores que se
// pueden combinar: cada combinación elige la variante que corresponde y el tema
// actualiza el precio solo. Una variante combinada se nombra con las partes
// unidas por " + " (ej. "Libro + Mate"), y cada parte es el comienzo del nombre
// del adicional suelto.
(function () {
  var SIN = /^sin adicional/i;

  function normalizar(texto) {
    return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function precio(centavos) {
    return '+$' + Math.round(centavos / 100).toLocaleString('es-AR');
  }

  function iniciar() {
    var inputs = [].slice.call(document.querySelectorAll('.single-option-selector__radio'));
    var sin = inputs.filter(function (i) { return SIN.test(i.value); })[0];
    if (!sin) return;
    var fieldset = sin.closest('fieldset');
    if (!fieldset || fieldset.dataset.paniAdic) return;
    fieldset.dataset.paniAdic = '1';

    var propios = [].slice.call(fieldset.querySelectorAll('.single-option-selector__radio'));
    var combos = propios.filter(function (i) { return i.value.indexOf(' + ') !== -1; });
    var sueltos = propios.filter(function (i) { return i !== sin && combos.indexOf(i) === -1; });
    if (!sueltos.length) return;

    function labelDe(input) { return fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]'); }

    // Qué sueltos forman cada combinación.
    var partesDe = new Map();
    combos.forEach(function (c) {
      var partes = c.value.split(' + ').map(function (parte) {
        return sueltos.filter(function (s) { return normalizar(s.value).indexOf(normalizar(parte)) === 0; })[0];
      });
      if (partes.every(Boolean)) partesDe.set(c, partes);
    });

    function elegidosDe(input) {
      if (input === sin) return [];
      if (partesDe.has(input)) return partesDe.get(input).slice();
      return [input];
    }

    function destino(elegidos) {
      if (!elegidos.length) return sin;
      if (elegidos.length === 1) return elegidos[0];
      var encontrado = null;
      partesDe.forEach(function (partes, combo) {
        if (partes.length === elegidos.length && partes.every(function (p) { return elegidos.indexOf(p) !== -1; })) encontrado = combo;
      });
      return encontrado;
    }

    fieldset.classList.add('pani-adic');
    [sin].concat(combos).forEach(function (i) { var l = labelDe(i); if (l) l.hidden = true; });

    var actual = propios.filter(function (i) { return i.checked; })[0] || sin;
    var elegidos = elegidosDe(actual);

    function pintar() {
      sueltos.forEach(function (s) {
        var l = labelDe(s);
        if (!l) return;
        var on = elegidos.indexOf(s) !== -1;
        l.classList.toggle('is-on', on);
        l.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    sueltos.forEach(function (s) {
      var l = labelDe(s);
      if (!l) return;
      l.setAttribute('role', 'button');
      l.setAttribute('tabindex', '0');
      function alternar(e) {
        e.preventDefault();
        var nuevos = elegidos.indexOf(s) !== -1
          ? elegidos.filter(function (x) { return x !== s; })
          : elegidos.concat(s);
        var input = destino(nuevos);
        if (!input) return; // combinación que no existe como variante
        elegidos = nuevos;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        pintar();
      }
      l.addEventListener('click', alternar);
      l.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') alternar(e); });
    });

    var ayuda = document.createElement('p');
    ayuda.className = 'pani-adic__ayuda';
    ayuda.textContent = 'Sumá los que quieras. Tocá de nuevo para sacarlo.';
    fieldset.appendChild(ayuda);
    pintar();

    // Precio de cada adicional, sacado de la diferencia entre variantes.
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var opcion = fieldset.querySelector('.single-option-selector__radio').dataset.index; // "option2"
      var base = p.variants.filter(function (v) { return v[opcion] === sin.value; })[0];
      if (!base) return;
      sueltos.forEach(function (s) {
        var v = p.variants.filter(function (x) { return x[opcion] === s.value; })[0];
        var l = labelDe(s);
        if (!v || !l || v.price <= base.price) return;
        var span = document.createElement('span');
        span.className = 'pani-adic__precio';
        span.textContent = precio(v.price - base.price);
        l.appendChild(span);
      });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
